import type { PoiPhotoDto } from '@camper-diary/shared';
import { api, HttpError } from './client';

export type PoiPhoto = PoiPhotoDto;

export function listPoiPhotos(poiId: string) {
  return api<PoiPhoto[]>(`/pois/${encodeURIComponent(poiId)}/photos`);
}

export async function uploadPoiPhoto(poiId: string, file: File): Promise<PoiPhoto> {
  const fd = new FormData();
  fd.append('file', file, file.name);
  return api<PoiPhoto>(`/pois/${encodeURIComponent(poiId)}/photos`, {
    method: 'POST',
    body: fd,
  });
}

export function deletePoiPhoto(id: string) {
  return api<null>(`/poi-photos/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export { HttpError };
